import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ChevronsLeft: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm11 17-5-5 5-5' }],
    ['path', { d: 'm18 17-5-5 5-5' }],
  ],
];

export default ChevronsLeft;
